"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));

var _utils = require("./utils");

var _constants = require("./constants");

var _constants2 = require("../../utils/constants");

var _color = _interopRequireDefault(require("color"));

var Styles = _tinymce["default"].html.Styles();

var IMG_VALID_ATTRS = ['data-cid', 'data-src', 'data-mce-src', 'src'];

var _default = function _default(editor, _ref) {
  var appearanceModeRef = _ref.appearanceModeRef;
  editor.serializer.addAttributeFilter('data-cid', function (nodes, name) {
    nodes.forEach(function (node) {
      var cid = node.attr('data-cid');
      node.attr('data-cid', null);
      node.attr('src', "cid:".concat(cid));
    });
  });
  editor.serializer.addAttributeFilter('data-src', function (nodes, name) {
    nodes.forEach(function (node) {
      var src = node.attr('data-src');
      node.attr('data-src', null);
      node.attr('src', src);
    });
  });
  editor.serializer.addAttributeFilter('data-mce-src', function (nodes, name) {
    nodes.forEach(function (node) {
      var src = node.attr('data-mce-src');
      node.attr('data-mce-src', null);
      node.attr('src', src);
    });
  });
  editor.serializer.addNodeFilter('img', function (nodes) {
    nodes.forEach(function (node) {
      if (IMG_VALID_ATTRS.every(function (item) {
        return !node.attr(item);
      })) {
        node.remove();
      }
    });
  });
  editor.serializer.addNodeFilter('div', function (nodes) {
    nodes.forEach(function (node) {
      if (node.attr('class') === 'uploading-placeholder') {
        node.remove();
      }
    });
  });
  editor.serializer.addAttributeFilter('data-bogus', function (nodes) {
    nodes.forEach(function (node) {
      return node.remove();
    });
  });
  editor.serializer.addAttributeFilter('style', function (nodes) {
    nodes.forEach(function (node) {
      if (!node.attr('style')) {
        node.attr('style', null);
        return;
      }

      var mceStyle = Styles.parse(node.attr('style'));
      var mceColor = mceStyle.color;
      var origFontColor = node.attr('data-color'); // If the mceColor is not the same as origFontColor, a new color is set via the Color Picker

      var isOriginalColor = mceColor && origFontColor && mceColor === origFontColor;

      if (!isOriginalColor) {
        (0, _utils.applyNodeStyle)(Styles, node, {
          color: mceColor
        });
      } else if (origFontColor) {
        (0, _utils.applyNodeStyle)(Styles, node, {
          color: origFontColor
        });
      }

      var mceBackgroundColor = mceStyle['background-color'];
      if (!(0, _utils.isValidColor)(mceBackgroundColor)) return;

      if (appearanceModeRef.current === _constants2.themeMode.DARK && (0, _color["default"])(mceBackgroundColor).hex() === (0, _color["default"])(_constants.HIGHLIGHT_DARK_COLOR).hex()) {
        (0, _utils.applyNodeStyle)(Styles, node, {
          'background-color': _constants.HIGHLIGHT_LIGHT_COLOR
        });
        return;
      }

      var origBackgroundColor = node.attr('data-background-color');
      var isOriginalBackgroundColor = mceBackgroundColor && origBackgroundColor && mceBackgroundColor === origBackgroundColor;

      if (!isOriginalBackgroundColor) {
        (0, _utils.applyNodeStyle)(Styles, node, {
          'background-color': mceBackgroundColor
        });
      } else if (origBackgroundColor) {
        (0, _utils.applyNodeStyle)(Styles, node, {
          'background-color': origBackgroundColor
        });
      }
    });
  });
  editor.serializer.addAttributeFilter('data-color', function (nodes) {
    nodes.forEach(function (node) {
      return node.attr('data-color', null);
    });
  });
  editor.serializer.addAttributeFilter('data-background-color', function (nodes) {
    nodes.forEach(function (node) {
      return node.attr('data-background-color', null);
    });
  });
  editor.serializer.addAttributeFilter('data-bgcolor', function (nodes) {
    nodes.forEach(function (node) {
      var bgColor = node.attr('data-bgcolor');
      node.attr('bgcolor', bgColor);
      node.attr('data-bgcolor', null);
    });
  });
};

exports["default"] = _default;
//# sourceMappingURL=serializer.js.map